import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CMSProvider, useCMS } from './context/CMSContext';

// Komponenter
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Sider
import Home from './pages/Home';
import ServiceChiropractic from './pages/ServiceChiropractic';
import ServiceCanine from './pages/ServiceCanine';
import About from './pages/About';
import Contact from './pages/Contact';
import Prices from './pages/Prices';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function AppContent() {
  const { loading, error } = useCMS();

  // Rolig og professionel indlæsningsskærm
  if (loading) {
    return (
      <div className="min-h-screen bg-brand-cream flex flex-col items-center justify-center p-6 text-center">
        <div className="flex flex-col items-center gap-4">
          <img 
            src="https://assets.auxodev.dk/cdn-cgi/image/width=360,quality=90,format=auto/assets/19a97e0e-8e3c-4b11-bc4c-e5bcc52ff735/equigram-logo.png" 
            alt="EquiGramVet" 
            className="h-20 sm:h-24 w-auto object-contain animate-pulse"
          />
          <div className="flex flex-col gap-1">
            <span className="text-xs text-brand-brown/80 font-medium tracking-wide">Indlæser professionel dyrebehandling...</span>
          </div>
        </div>
      </div>
    );
  }

  // Fejlskærm hvis CMS ikke kan indlæses
  if (error) {
    return (
      <div className="min-h-screen bg-brand-cream flex flex-col items-center justify-center p-6 text-center">
        <div className="max-w-md flex flex-col items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-red-100 text-red-700 flex items-center justify-center text-xl">
            <i className="fa-regular fa-circle-exclamation" />
          </div>
          <h2 className="font-serif text-xl font-bold text-brand-dark">Der skete en fejl</h2>
          <p className="text-brand-brown text-sm leading-relaxed">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="mt-2 px-5 py-2.5 bg-brand-dark text-brand-cream text-sm font-medium rounded-brand hover:bg-brand-brown transition-colors duration-200"
          >
            Prøv igen
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-brand-cream text-brand-dark antialiased">
      <ScrollToTop />
      <Header />
      
      {/* Hovedindhold */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/kiropraktik" element={<ServiceChiropractic />} />
          <Route path="/kiropraktik-til-hunde" element={<ServiceCanine />} />
          <Route path="/om-equigramvet" element={<About />} />
          <Route path="/priser" element={<Prices />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/403" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default function App() {
  return (
    <CMSProvider>
      <AppContent />
    </CMSProvider>
  );
}
